module.exports = __webpack_public_path__ + "static/line_gold-c128587dcac63aa0feb7216ae571e4e8.png";